import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ProductPreview, Translatable } from 'piwe-front-swagger-client';
import { Subscription } from 'rxjs';
import { HomepageCreatorDataService } from 'src/app/cms/web-administration/homepage-administration/homepage-creator/homepage-creator-data.service';

@Component({
  selector: 'app-homepage-section-big',
  templateUrl: './homepage-section-big.component.html',
  styleUrls: ['./homepage-section-big.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomepageSectionBigComponent implements OnInit {
  @Input() mediaData!: ProductPreview | null;

  public noImgSectionUrl: string = '';
  public productTitle: string = '';
  public productTitleEn: string = '';

  @Input() pagebuilderMode: boolean = true;

  public currentLanguage = 'hr';
  private currentLanguageSubscription = new Subscription();

  constructor(
    private homepageCreatorDataService: HomepageCreatorDataService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.noImgSectionUrl = this.homepageCreatorDataService.noImgSectionUrl;

    this.productTitle =
      this.mediaData?.title?.find((t: Translatable) => t.language == 'HR')
        ?.content ?? '';
    this.productTitleEn =
      this.mediaData?.title?.find((t: Translatable) => t.language == 'EN')
        ?.content ?? '';

    //translation
    this.currentLanguage = this.translateService.currentLang;
    this.currentLanguageSubscription =
      this.translateService.onLangChange.subscribe(
        (params: LangChangeEvent) => {
          this.currentLanguage = params.lang;
        }
      );
  }

  calculateUrl(url: string): string {
    return url.replace('photo/preview/', 'photo/pnw/');
  }

  ngOnDestroy() {
    this.currentLanguageSubscription.unsubscribe();
  }
}
